module.exports = __webpack_public_path__ + "img/green-1-squiggly-striped.4afb57ba.svg";